import { createContext, useContext, useState, type PropsWithChildren } from "react";

interface NavContextValue {
  /** Mobil navigasyon çekmecesi açık mı? */
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
}

const NavContext = createContext<NavContextValue>({
  mobileOpen: false,
  setMobileOpen: () => {},
});

/** İki katmanlı sider ile Header hamburger'ını eşgüdümler. */
export const useNav = () => useContext(NavContext);

export const NavProvider = ({ children }: PropsWithChildren) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <NavContext.Provider value={{ mobileOpen, setMobileOpen }}>
      {children}
    </NavContext.Provider>
  );
};
